import { useEffect } from 'react';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Sparkles, CheckCircle } from 'lucide-react';
import confetti from 'canvas-confetti';

export default function AhaSummaryCard({ summary, onClose }) {
  useEffect(() => {
    if (summary) {
      confetti({ particleCount: 80, spread: 60, origin: { y: 0.5 }, colors: ['#3B82F6', '#10B981', '#F59E0B'] });
    }
  }, [summary]);

  if (!summary) return null;

  return (
    <Dialog open={!!summary} onOpenChange={() => onClose()}>
      <DialogContent className="sm:max-w-md rounded-3xl p-0 border-0 overflow-hidden" data-testid="aha-summary-card">
        <div className="glass-panel p-8">
          {/* Header */}
          <div className="text-center mb-6">
            <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-amber-400 to-amber-500 mx-auto mb-3 flex items-center justify-center shadow-lg shadow-amber-500/20">
              <Sparkles className="w-7 h-7 text-white" />
            </div>
            <h2 className="font-heading text-xl font-bold text-slate-900" data-testid="aha-title">
              {summary.title}
            </h2>
          </div>

          {/* Summary Points */}
          <div className="space-y-2 mb-5">
            {summary.summary_points?.map((point, i) => (
              <div key={i} className="flex items-start gap-2">
                <CheckCircle className="w-4 h-4 text-emerald-500 mt-0.5 flex-shrink-0" />
                <p className="text-sm font-body text-slate-600">{point}</p>
              </div>
            ))}
          </div>

          {/* Cheat Sheet */}
          {summary.cheat_sheet && (
            <div className="bg-blue-50 rounded-2xl p-4 mb-5" data-testid="aha-cheat-sheet">
              <p className="text-xs text-blue-500 font-heading font-semibold uppercase tracking-wider mb-1">Cheat Sheet</p>
              <p className="text-sm font-body text-blue-800">{summary.cheat_sheet}</p>
            </div>
          )}

          {/* Encouragement */}
          <p className="text-sm text-slate-600 font-body text-center italic mb-6" data-testid="aha-encouragement">
            "{summary.encouragement}"
          </p>

          <Button data-testid="aha-close-btn" onClick={onClose}
            className="w-full bg-blue-500 hover:bg-blue-600 text-white rounded-full font-heading">
            Continue Learning
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
